import { useQuery } from '@tanstack/react-query';

import restClient from '../util/web-http-client';

export const useGeoOmraade = () => {
    return useQuery({
        queryKey: ['geoOmraade'],
        queryFn: () => restClient.getGeoOmraade(),
    });
};
